import { AuthModule } from "./Public/_Auth/_MODULES/AuthModule";
import { ArchiveModule } from "./Private/_Archive/_MODULES/ArchiveModule";
import { TagsModule } from "./Private/_Tags/_MODULES/TagsModule";
import { CONFIG_PLUGIN } from "../../_CORE/_Config/Plugins/_Config.Plugin";
import { ProfileModule } from "./Private/_Profile/_MODULES/ProfileModule";
import { ProjectsModule } from "./Private/_Projects/_MODULES/ProjectsModule";
import { DashboardModule } from "./Private/_Dashboard/_MODULES/DashboardModule";
import { CompaniesModule } from "./Private/_Companies/_MODULES/CompaniesModule";
import { PersonalVaultModule } from "./Private/_PersonalVault/_MODULES/PersonalVaultModule";
import { ManualsModule } from "./Private/_Manuals/_MODULES/ManualsModule";
import { CoursesModule } from "./Private/_Courses/_MODULES/CoursesModule";
import { LibraryModule } from "./Private/_Library/_MODULES/LibraryModule";
import { SavingsModule } from "./Private/_Savings/_MODULES/SavingsModule";
import { MonthlyExpensesModule } from "./Private/_MonthlyExpenses/_MODULES/MonthlyExpensesModule";
import { WorkspaceModule } from "./Private/_Workspace/_MODULES/WorkspaceModule";
import { ToolsModule } from "./Private/_Tools/_MODULES/ToolsModule";
import { CommandsModule } from "./Private/_Commands/_MODULES/CommandsModule";
import { SnippetsModule } from "./Private/_Snippets/_MODULES/SnippetsModule";
import { WishlistModule } from "./Private/_Wishlist/_MODULES/WishlistModule";
import { ContactsModule } from "./Private/_Contacts/_MODULES/ContactsModule";
import { NotebookModule } from "./Private/_Notebook/_MODULES/NotebookModule";
import { StickyNotesModule } from "./Private/_StickyNotes/_MODULES/StickyNotesModule";
import { CenterModule } from "./Private/_Center/_MODULES/CenterModule";

// Return a module only when its feature flag is enabled.
const DISPLAY_MODULE = (enabled, moduleFn) => (enabled ? moduleFn : () => []);

// PUBLIC ROUTES ONLY
export const APP_MODULES_GET_PUBLIC_ROUTES = (dataUser = null, lang = "es") => [
    ...AuthModule(dataUser, lang),
];

export const APP_MODULES = [

    // --------------------------------------- PUBLIC MODULES
    AuthModule,

    // --------------------------------------- PRIVATE MODULES
    DashboardModule,
    CenterModule,
    WorkspaceModule,
    ToolsModule,
    CommandsModule,
    SnippetsModule,
    WishlistModule,
    ContactsModule,
    NotebookModule,
    StickyNotesModule,
    CompaniesModule,
    ProjectsModule,
    PersonalVaultModule,
    ManualsModule,
    LibraryModule,
    SavingsModule,
    MonthlyExpensesModule,
    CoursesModule,
    TagsModule,
    ArchiveModule,
    ProfileModule,

];

export const APP_MODULES_GET_PRIVATE_ROUTES = (dataUser = null, lang = "es") => [

    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_DASHBOARD, DashboardModule)(dataUser, lang),
    ...CenterModule(dataUser, lang),
    ...WorkspaceModule(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_TOOLS, ToolsModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_COMMANDS, CommandsModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_SNIPPETS, SnippetsModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_WISHLIST, WishlistModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_CONTACTS, ContactsModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_NOTEBOOK, NotebookModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_STICKY_NOTES, StickyNotesModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_COMPANIES, CompaniesModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_PROJECTS, ProjectsModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_PERSONAL_VAULT, PersonalVaultModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_MANUALS, ManualsModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_LIBRARY, LibraryModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_SAVINGS, SavingsModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_MONTHLY_EXPENSES, MonthlyExpensesModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_COURSES, CoursesModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_TAGS, TagsModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_ARCHIVE, ArchiveModule)(dataUser, lang),
    ...DISPLAY_MODULE(CONFIG_PLUGIN.MODULES.HAS__MODULE_PROFILE, ProfileModule)(dataUser, lang),

];

export const APP_MODULES_GET_ALL_ROUTES = (dataUser = null, lang = "es") => [
    ...APP_MODULES_GET_PUBLIC_ROUTES(dataUser, lang),
    ...APP_MODULES_GET_PRIVATE_ROUTES(dataUser, lang),
];
